import { createSlice } from '@reduxjs/toolkit'

import api, { createWrappedAsyncThunk } from 'src/api'

export const initialState = {
  profile: null,
  users: [],
}

const SLICE_NAME = 'admin'

// Users
export const fetchUsers = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchUsers`,
  args => api.get('/supplier/useradmin/')
)

export const addUsers = createWrappedAsyncThunk(
  `${SLICE_NAME}/addUsers`,
  args => api.post('/supplier/useradmin/', { body: args })
)

export const updateUsers = createWrappedAsyncThunk(
  `${SLICE_NAME}/updateUsers`,
  args => api.patch(`/supplier/useradmin/${args.id}/`, { body: args })
)

export const deleteUsers = createWrappedAsyncThunk(
  `${SLICE_NAME}/deleteUsers`,
  args => api.del(`/supplier/useradmin/${args}/delete/`)
)

export const restoreUsers = createWrappedAsyncThunk(
  `${SLICE_NAME}/restoreUsers`,
  args => api.post(`/supplier/useradmin/${args}/restore/`)
)

// Supplier profile
export const fetchProfile = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchProfile`,
  args => api.get('/supplier/profile/')
)

export const updateProfile = createWrappedAsyncThunk(
  `${SLICE_NAME}/updateProfile`,
  params => api.patch('/supplier/profile/', { body: params })
)

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: {
    // Users
    [fetchUsers.fulfilled]: (state, { payload }) => {
      state.users = payload
      return state
    },
    [addUsers.fulfilled]: (state, { payload }) => {
      state.users.push(payload)
      return state
    },
    [updateUsers.fulfilled]: (state, { meta, payload }) => {
      const { arg } = meta
      const index = state.users.findIndex(u => u.id === arg.id)
      state.users[index] = payload
      return state
    },
    [deleteUsers.fulfilled]: (state, { meta, payload }) => {
      const { arg } = meta
      const index = state.users.findIndex(u => u.id === arg)
      state.users[index] = payload
      return state
    },
    [restoreUsers.fulfilled]: (state, { meta, payload }) => {
      const { arg } = meta
      const index = state.users.findIndex(u => u.id === arg)
      state.users[index] = payload
      return state
    },
    // Profile
    [fetchProfile.fulfilled]: (state, { meta, payload }) => {
      state.profile = payload
      return state
    },
    [updateProfile.fulfilled]: (state, { meta, payload }) => {
      state.profile = payload
      return state
    },
  },
})

export default slice.reducer
